export enum TransportTaskType {
    Created = 0,
    PickedUp = 1,
    Delivered = 2,
    Cancelled = 3,
    Failed = 4,
    Added = 5,
    Updated = 6,
    Deleted = 7,
}

export const transportTaskTypeNames: Readonly<Record<TransportTaskType, string>> = Object.freeze({
    [TransportTaskType.Created]: "transport.taskType.created",
    [TransportTaskType.PickedUp]: "transport.taskType.pickedUp",
    [TransportTaskType.Delivered]: "transport.taskType.delivered",
    [TransportTaskType.Cancelled]: "transport.taskType.cancelled",
    [TransportTaskType.Failed]: "transport.taskType.failed",
    [TransportTaskType.Added]: "transport.taskType.added",
    [TransportTaskType.Updated]: "transport.taskType.updated",
    [TransportTaskType.Deleted]: "transport.taskType.deleted",
});
